import React, { useState } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import { reviews } from "../data/reviews";
import { GOOGLE_REVIEW_URL } from "../data/videos";

export const Avis = () => {
  const [showAll, setShowAll] = useState(false);
  const [page, setPage] = useState(0);
  const perPage = 3;
  const visible = showAll ? reviews : reviews.slice(page * perPage, page * perPage + perPage);
  const totalPages = Math.ceil(reviews.length / perPage);

  return (
    <section id="avis" data-testid="avis-section" className="py-24 md:py-32 bg-[#0B1422]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#C9A869]" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#C9A869]">Avis élèves</span>
            <span className="h-px w-10 bg-[#C9A869]" />
          </div>
          <div className="flex items-center justify-center gap-1 mb-4">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} size={22} className="fill-[#C9A869] text-[#C9A869]" />
            ))}
            <span className="ml-3 serif text-3xl text-[#F7F3EA]">5/5</span>
            <span className="ml-2 text-sm text-[#F7F3EA]/60">— 10 avis</span>
          </div>
          <h2 className="serif font-light text-4xl md:text-5xl lg:text-6xl text-[#F7F3EA] tracking-tight">
            Des élèves qui <span className="italic gold-text">progressent vite</span>.
          </h2>
          <p className="mt-5 text-sm md:text-base text-[#F7F3EA]/70 max-w-2xl mx-auto font-light">
            Une ambiance bienveillante, des progrès concrets, et le plaisir retrouvé sur le dancefloor.
          </p>
        </div>

        <div className={`grid ${showAll ? "md:grid-cols-2 lg:grid-cols-3" : "md:grid-cols-3"} gap-6`}>
          {visible.map((r, i) => (
            <article
              key={i}
              data-testid={`review-card-${i}`}
              className="bg-[#1A2A40]/50 border border-[#C9A869]/20 p-8 md:p-10 hover:border-[#C9A869]/60 transition-colors duration-500 flex flex-col"
            >
              <div className="flex gap-1 mb-5">
                {Array.from({ length: r.rating }).map((_, j) => (
                  <Star key={j} size={14} className="fill-[#C9A869] text-[#C9A869]" />
                ))}
              </div>
              <p className="serif text-lg md:text-xl text-[#F7F3EA] leading-relaxed font-light mb-6 italic flex-1">
                « {r.text} »
              </p>
              <div className="flex items-center justify-between border-t border-[#C9A869]/20 pt-4">
                <span className="text-[#F7F3EA] font-medium tracking-wide">{r.name}</span>
                <span className="text-[10px] tracking-[0.25em] uppercase text-[#C9A869]/80">{r.source}</span>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-4">
          {!showAll && (
            <>
              <button
                onClick={() => setPage((p) => Math.max(0, p - 1))}
                disabled={page === 0}
                data-testid="reviews-prev"
                className="p-3 border border-[#C9A869]/40 text-[#C9A869] hover:bg-[#C9A869] hover:text-[#0E1A2B] transition-colors disabled:opacity-30"
              >
                <ChevronLeft size={16} />
              </button>
              <span className="text-xs tracking-[0.2em] uppercase text-[#F7F3EA]/60">
                {page + 1} / {totalPages}
              </span>
              <button
                onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
                disabled={page === totalPages - 1}
                data-testid="reviews-next"
                className="p-3 border border-[#C9A869]/40 text-[#C9A869] hover:bg-[#C9A869] hover:text-[#0E1A2B] transition-colors disabled:opacity-30"
              >
                <ChevronRight size={16} />
              </button>
            </>
          )}
          <button
            onClick={() => setShowAll((s) => !s)}
            data-testid="reviews-toggle-all"
            className="ml-3 px-7 py-3 border border-[#C9A869] text-[#C9A869] text-[11px] tracking-[0.25em] uppercase hover:bg-[#C9A869] hover:text-[#0E1A2B] transition-colors duration-500"
          >
            {showAll ? "Voir moins" : "Voir tous les avis"}
          </button>
        </div>

        <div className="mt-14 pt-10 border-t border-[#C9A869]/20 flex flex-col items-center text-center">
          <p className="text-[10px] tracking-[0.4em] uppercase text-[#C9A869] mb-3">
            Vous avez suivi un cours ?
          </p>
          <p className="serif text-2xl md:text-3xl text-[#F7F3EA] font-light mb-5 max-w-xl">
            Partagez votre expérience sur <span className="italic gold-text">Google</span>.
          </p>
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="avis-google-cta"
            className="inline-flex items-center gap-3 px-7 py-3 bg-[#C9A869] text-[#0E1A2B] text-[11px] tracking-[0.25em] uppercase font-medium hover:bg-[#DCC28E] transition-colors duration-500"
          >
            <Star size={14} fill="#0E1A2B" />
            Laisser un avis Google
          </a>
        </div>
      </div>
    </section>
  );
};
